import { h, svgUse } from '../../../utils/dom.js';
import { t } from '../../../i18n/index.js';
import { registerDropdown, toggleDropdown } from '../../../hooks/useDropdown.js';
import { notificationsService } from '../../../services/notificationsService.js';
import { EmptyState } from '../../common/EmptyState.js';

export function NotificationsMenu() {
  const btn = h('button', { class: 'icon-btn', 'aria-label': 'notifications',
    onclick: (e) => { e.stopPropagation(); toggleDropdown(menu); },
  }, svgUse('ic-bell'), h('span', { class: 'dot' }));

  const menu = h('div', { class: 'dropdown', id: 'bellMenu' });
  registerDropdown(menu);

  // Load notifications asynchronously
  notificationsService.list().then((items) => {
    menu.innerHTML = '';
    if (!items || items.length === 0) {
      menu.appendChild(EmptyState({ message: t('notificationsEmpty'), icon: 'ic-bell' }));
      return;
    }
    items.forEach((n) => {
      menu.appendChild(
        h('div', { class: 'notif-item' },
          h('p', {}, t(n.titleKey)),
          h('span', {}, t(n.timeKey)),
        )
      );
    });
  }).catch(() => {
    menu.innerHTML = '';
    menu.appendChild(EmptyState({ message: t('errorTitle') }));
  });

  const el = h('div', { class: 'avatar-wrap' }, btn, menu);
  return { el };
}